export default {
  // 登录
  login: 'backend.org.ums.user.login',

  // 获取当前登录用户信息
  userInfo: 'backend.org.ums.userInfo.get',

  // 上传单个文件接口
  upload: 'backend.org.sys.file.upload'
}
